import { render, staticRenderFns } from "./AtencionShow.vue?vue&type=template&id=1b642d4e&scoped=true"
import script from "./AtencionShow.vue?vue&type=script&lang=ts"
export * from "./AtencionShow.vue?vue&type=script&lang=ts"
import style0 from "./AtencionShow.vue?vue&type=style&index=0&id=1b642d4e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b642d4e",
  null
  
)

export default component.exports